
export const participationStatusMap = {'attending': ['90% Confirmed',
                                                'REGI IN - re-booking',
                                                '100% Confirmed',
                                                'at Event'],
                                   'cancelled': ['100% Confirmed - no show',
                                                 'Cancellation - no reason',
                                                 'Cancellation - other important meeting',
                                                 'Cancellation - other reason',
                                                 'Cancellation - sick'],
                                   'pipeline': ['0% Confirmed',
                                                '20% Confirmed',
                                                '50% Confirmed'],
                                    'special': ['100% Confirmed - no show']}
